import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';
import { brandColors } from 'styles/colors';

export const Card = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	background-color: white;
	padding: 2%;
	height: 15vh;
	justify-content: space-around;

	@media (max-width: 1440px) {
		height: 18vh;
	}
	@media (max-width: 1366px) {
		height: 18vh;
	}
`;

export const ContentWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	gap: 20px;
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
`;

export const Title = styled.h2`
	font-size: 18px;
	margin: 0;
	color: #333;
	cursor: default;
`;

export const Description = styled.p`
	text-align: left;
	font-size: 14px;
	color: #666;
	margin: 8px 0;
	font-weight: 400;
	cursor: default;
`;

export const ReadMore = styled.a`
	display: flex;
	align-items: center;
	color: ${colors.grey6};
	font-weight: bold;
	text-decoration: none;
	cursor: pointer;
	svg {
		margin-left: 8px;
	}
	&:hover {
    svg {
      transform: translateX(5px);
      transition: transform 0.3s ease-in-out;
    }
  }
	&:hover {
		color: ${brandColors.green}
		transition: all 0.3s ease-in-out;
	}
`;

export const ActionWrapper = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	flex-direction: row;
`;

export const Tag = styled.div`
	cursor: default;
	color: ${colors.black};
	display: inline-block;
	padding: 5px 10px;
	background-color: ${({ isIndustry }) =>
		isIndustry ? `${colors.blue100}` : `${colors.violet100}`};
	border-radius: 15px;
	font-size: 13px;
`;
